module.exports = __webpack_public_path__ + "img/sms_mailer_phone.2db03dc0.svg";